import React from 'react';
import { Text } from '../styles/title.style';
/**
 * Title Component
 * @param {object} props Incoming props
 * @returns {XML} A title component
 */
const Title = ({ black, center, children }) => (
  <Text className="component-title" isBlack={black} center={center}>
    {center ? '' : <hr className="accent" />}
    <h3>{children}</h3>
    {center ? <hr className="accent center" /> : ''}
  </Text>
);

export default Title;



// WEBPACK FOOTER //
// ./src/components/title/components/title.js